module.exports = __webpack_public_path__ + "static/media/fly0212.e423b85a.webp";